import { MdInsertPageBreak, MdOutlineDashboardCustomize, MdOutlineSettingsSuggest, MdOutlineShoppingCart } from "react-icons/md";

//Page Title: Dynamics CRM Integration
export const dcrmData = [
  {
    title: "Plugin Configuration and Object Mapping Overview",
    video:true,
    videoId: "6Igj4CiRNww",
    videoType: "youtube",
    icon: <MdOutlineSettingsSuggest className='text-white fs-5' />
  },
  {
    title: "WooCommerce Manager (Products / Orders / Customers Sync)",
    video:true,
    videoId: "DMYHuYUTySE",
    videoType: "youtube",
    icon: <MdOutlineShoppingCart className='text-white fs-5' />
  },
  {
      title: "Forms Integration (Leads / Contacts / Case Generation)",
      video: true,
      videoId: "gG_SOFF92rU",
      videoType: "youtube",
      icon: <MdOutlineDashboardCustomize className='text-white fs-5' />
    },
    {
      title: "Display Dynamics CRM Data on WordPress Pages/Posts",
      video:true,
      videoId: "fw21BQpLmgE",
      videoType: "youtube",
      icon: <MdInsertPageBreak className='text-white fs-5' />
    }
]